export default function MarketSection() {
  return (
    <section id="market" className="market-section">
      <div className="market-inner">
        <div style={{ textAlign: 'center' }}>
          <div className="eyebrow-label" style={{ justifyContent: 'center' }}>Market Opportunity</div>
          <h2>A $16 Trillion Market in <span>Permanent Transition</span></h2>
          <p className="lead">
            The convergence of regulation, institutional adoption, and technology is creating the largest infrastructure opportunity in capital markets history.
          </p>
        </div>

        <div className="market-grid">
          <div className="mcard">
            <div className="mcard-val">$2.1T</div>
            <div className="mcard-label">Raised under Regulation D in 2024</div>
            <div className="mcard-source">Source: SEC DERA Market Statistics</div>
          </div>
          <div className="mcard">
            <div className="mcard-val">$16T</div>
            <div className="mcard-label">Tokenized real-world assets by 2030</div>
            <div className="mcard-source">Source: BCG &amp; ADDX Research</div>
          </div>
          <div className="mcard">
            <div className="mcard-val">30K</div>
            <div className="mcard-label">Middle-market issuers raising $500K–$50M annually</div>
            <div className="mcard-source">Source: SEC Form D Filings</div>
          </div>
        </div>

        <div className="market-catalysts">
          <div className="catalyst">
            <div className="cat-date">July 2025 · Federal Law</div>
            <div className="cat-title">GENIUS Act Signed into Law</div>
            <div className="cat-text">
              The first comprehensive U.S. digital asset legislation. Stablecoins are now legal on-chain settlement currency, unlocking atomic settlement for institutional capital markets — the legal foundation VYASA was built for.
            </div>
          </div>
          <div className="catalyst">
            <div className="cat-date">September 2025 · SEC Filing</div>
            <div className="cat-title">Nasdaq Files for Tokenized Securities</div>
            <div className="cat-text">
              Nasdaq filed with the SEC to permit trading of tokenized equities and ETFs — validating the infrastructure play Apex has been building since inception. Member firms may now choose traditional or tokenized settlement.
            </div>
          </div>
          <div className="catalyst">
            <div className="cat-date">January 2026 · Platform Launch</div>
            <div className="cat-title">NYSE Builds Tokenized Platform</div>
            <div className="cat-text">
              NYSE announced a blockchain-based platform for 24/7 trading and on-chain settlement of tokenized U.S. stocks and ETFs in partnership with BNY and Citi — accelerating the institutional adoption curve.
            </div>
          </div>
        </div>

        <div className="market-quote">
          <p>"Tokenization is as revolutionary as email versus the postal service. The question is not if — only who builds the infrastructure that wins."</p>
          <cite>— Larry Fink, CEO, BlackRock</cite>
        </div>
      </div>
    </section>
  );
}
